"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterableList = exports.zeroResultsVisibleClass = exports.ListStatusCode = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const app_1 = require("app");
const React = require("react");
const actions_1 = require("src/actions");
const FullTextSearchApi_1 = require("src/search/fullText/FullTextSearchApi");
const webexUI_1 = require("webexUI");
const SortButton_1 = require("../../Components/SortButton");
const index_1 = require("../../Pages/index");
const DocumentsHeader_1 = require("../../Pages/SearchResults/components/DocumentsHeader");
const DocumentsSearchField_1 = require("../../Pages/SearchResults/components/DocumentsSearchField");
const DidYouMean_1 = require("../DidYouMean");
const ErrorHandlerComponent_1 = require("../ErrorHandler/ErrorHandlerComponent");
const Filters_1 = require("../Filters/Filters");
const FilterTypings_1 = require("../Filters/FilterTypings");
const MobileFilter_1 = require("../Filters/MobileFilter");
const UnselectButtonsGroup_1 = require("../Filters/UnselectButtonsGroup");
const InfoBox_1 = require("../InfoBox");
const Pagination_1 = require("../Pagination");
const ErrorMessage_1 = require("./ErrorMessage");
const FilterableListItems_1 = require("./FilterableListItems");
const ZeroResultsContainer_1 = require("./ZeroResultsContainer");
const ZeroSearchResults_1 = require("Views/Partials/Components/ZeroSearchResults/ZeroSearchResults");
const zeroResultsMessage_1 = require("./zeroResultsMessage");
const DownloadSortButton_1 = require("../DownloadSortButton");
const MosaicIcon_1 = require("Views/Shared/Components/MosaicIcon");
const Spinner_1 = require("Views/Shared/Components/Spinner/Spinner");
const SideBar_1 = require("Views/Shared/Components/SideBar/SideBar");
var ListStatusCode;
(function (ListStatusCode) {
    ListStatusCode[ListStatusCode["success"] = 0] = "success";
    ListStatusCode[ListStatusCode["communicationError"] = 1] = "communicationError";
    ListStatusCode[ListStatusCode["zeroResults"] = 2] = "zeroResults";
    ListStatusCode[ListStatusCode["inProgress"] = 3] = "inProgress";
})(ListStatusCode || (exports.ListStatusCode = ListStatusCode = {}));
exports.zeroResultsVisibleClass = 'zero-results-visible';
const FilterableList = props => {
    const { query, title, filterGroupsOrder, filters, selectedFilters, selectedFiltersQueryString, selectedFiltersCount, pageCount, pageNumber, pageSize, totalItems, status, items, waitingForResults, sortBy, suggestions, zeroResultsMessage, isDocumentsSearchPage, additionalData, informationMessage, isTitleHidden, } = props;
    const [mobileFilterVisible, setMobileFilterVisible] = React.useState(false);
    const [isContentLoading, setIsContentLoading] = React.useState(false);
    const breadcrumbsPlaceholder = React.useRef(null);
    React.useEffect(() => {
        var _a;
        const breadcrumbs = document.querySelector('.breadcrumbs');
        if (!breadcrumbs) {
            return undefined;
        }
        breadcrumbs.classList.remove('my-8', 'sm:my-12');
        (_a = breadcrumbsPlaceholder.current) === null || _a === void 0 ? void 0 : _a.appendChild(breadcrumbs);
    }, []);
    React.useEffect(() => {
        setIsContentLoading(false);
    }, [items]);
    React.useEffect(() => {
        (0, app_1.showBreadcrumbsInsideList)();
    });
    React.useEffect(() => () => app_1.overlayService.disableBodyScrollLock(), []);
    const hideZeroResultContent = React.useCallback((data) => {
        if (!data) {
            return;
        }
        if (data.zeroResultContent) {
            data.zeroResultContent.css({ height: 0, overflow: 'hidden' });
            data.zeroResultContent.removeClass(exports.zeroResultsVisibleClass);
        }
        if (data.contentPage) {
            data.contentPage.style.display = 'block';
        }
    }, []);
    const handleSetContentLoading = React.useCallback((value) => {
        setIsContentLoading(value);
    }, []);
    const getSelectedFiltersCount = React.useCallback(() => {
        return Object.keys(selectedFilters).reduce((acc, key) => acc + selectedFilters[key].length, 0);
    }, [selectedFilters]);
    const isMobileErrorMessage = React.useCallback(() => {
        return ((0, webexUI_1.detectBreakpoint)(webexUI_1.Breakpoint.SMScreen) &&
            !!status &&
            status.statusCode === ListStatusCode.communicationError &&
            !filterGroupsOrder.length);
    }, [filterGroupsOrder.length, status]);
    const changeFilterHandler = React.useCallback((groupValue, filterValue) => {
        setIsContentLoading(true);
        actions_1.ActionsController.dispatch(actions_1.FilterableListActions.pageChange(0, true));
        actions_1.ActionsController.dispatch(actions_1.FilterableListActions.pageSizeChange(10, true));
        actions_1.ActionsController.dispatch(actions_1.FilterableListActions.change(groupValue, filterValue));
    }, []);
    const cancelFilterHandler = React.useCallback((previousSelectedFilters) => {
        if (isMobileErrorMessage()) {
            return;
        }
        setIsContentLoading(true);
        actions_1.ActionsController.dispatch(actions_1.FilterableListActions.cancel(previousSelectedFilters));
    }, [isMobileErrorMessage]);
    const resetFilterHandler = React.useCallback(() => {
        setIsContentLoading(true);
        actions_1.ActionsController.dispatch(actions_1.FilterableListActions.pageChange(0, true));
        actions_1.ActionsController.dispatch(actions_1.FilterableListActions.pageSizeChange(10, true));
        actions_1.ActionsController.dispatch(actions_1.FilterableListActions.reset());
    }, []);
    const changeQueryHandler = React.useCallback((newQuery, isInitialSearch) => {
        actions_1.ActionsController.dispatch(actions_1.FilterableListActions.pageChange(0, true));
        actions_1.ActionsController.dispatch(actions_1.FilterableListActions.pageSizeChange(10, true));
        actions_1.ActionsController.dispatch(actions_1.FilterableListActions.queryChange(newQuery, isInitialSearch));
    }, []);
    const sortChangeHandler = React.useCallback((nextSort) => {
        setIsContentLoading(true);
        actions_1.ActionsController.dispatch(actions_1.FilterableListActions.sortChange(nextSort));
    }, []);
    const toggleMobileFilter = React.useCallback(() => {
        setMobileFilterVisible(prev => {
            const next = !prev;
            if (next) {
                app_1.overlayService.enableBodyScrollLock();
            }
            else {
                app_1.overlayService.disableBodyScrollLock();
            }
            return next;
        });
    }, []);
    const renderHeading = React.useCallback(() => {
        const hasVisibleTitle = !!status &&
            (status.statusCode === ListStatusCode.success ||
                status.statusCode === ListStatusCode.inProgress);
        const suppressTitle = isTitleHidden === null || isTitleHidden === void 0 ? void 0 : isTitleHidden(query);
        const heading = hasVisibleTitle ? title : null;
        if (suppressTitle) {
            return null;
        }
        return ((0, jsx_runtime_1.jsx)("h1", { className: "page-heading text-primary block my-3xl sm:my-5xl min-h-4xl sm:min-h-6xl break-all", children: heading }));
    }, [isTitleHidden, query, status, title]);
    const renderSpinner = React.useCallback(() => {
        if (!waitingForResults) {
            return null;
        }
        return ((0, jsx_runtime_1.jsx)("div", { className: "spinner-wrapper fixed top-0 left-0 right-0 h-screen w-full bg-white", children: (0, jsx_runtime_1.jsx)(Spinner_1.Spinner, { visible: true }) }));
    }, [waitingForResults]);
    const renderMobileFilter = React.useCallback(() => {
        if (!filterGroupsOrder.length) {
            return null;
        }
        return ((0, jsx_runtime_1.jsx)(ErrorHandlerComponent_1.ErrorHandlerComponent, { children: (0, jsx_runtime_1.jsx)(SideBar_1.Sidebar, { opened: mobileFilterVisible, closeBreakpoint: webexUI_1.Breakpoint.LGScreen, close: toggleMobileFilter, isAnimated: false, children: (0, jsx_runtime_1.jsx)(MobileFilter_1.default, { filterGroupsOrder: filterGroupsOrder, filters: filters, selectedFilters: selectedFilters, selectedFiltersCount: selectedFiltersCount, onFilterChange: changeFilterHandler, onFilterReset: resetFilterHandler, onCancel: cancelFilterHandler, waitingForResults: waitingForResults, close: toggleMobileFilter, dictionary: index_1.PageContext.dictionary, additionalData: additionalData, renderSpinner: renderSpinner }) }) }));
    }, [
        additionalData,
        cancelFilterHandler,
        changeFilterHandler,
        filterGroupsOrder,
        filters,
        mobileFilterVisible,
        renderSpinner,
        resetFilterHandler,
        selectedFilters,
        selectedFiltersCount,
        toggleMobileFilter,
        waitingForResults,
    ]);
    const renderTotalItems = React.useCallback(() => {
        if (totalItems < 1) {
            return null;
        }
        return ((0, jsx_runtime_1.jsxs)("div", { className: "list-total-count mt-4 md:mt-0 shrink-0", children: [index_1.PageContext.dictionary.numberOfItems, " (", totalItems, ")"] }));
    }, [totalItems]);
    const renderUnselectButtonsGroup = React.useCallback(() => {
        const unSelectFilterGroupsOrder = [...filterGroupsOrder];
        const typeFilterGroupPosition = filterGroupsOrder.indexOf('type');
        if (typeFilterGroupPosition > -1) {
            unSelectFilterGroupsOrder.splice(typeFilterGroupPosition, 1);
            unSelectFilterGroupsOrder.unshift('type');
        }
        return ((0, jsx_runtime_1.jsx)(ErrorHandlerComponent_1.ErrorHandlerComponent, { children: (0, jsx_runtime_1.jsx)(UnselectButtonsGroup_1.UnselectButtonsGroup, { filterGroupsOrder: unSelectFilterGroupsOrder, filters: filters, selectedFilters: selectedFilters, setIsContentLoading: setIsContentLoading }) }));
    }, [filterGroupsOrder, filters, selectedFilters, setIsContentLoading]);
    const renderSortButton = React.useCallback(() => {
        if (!index_1.PageContext.dictionary.sortBtnLabel) {
            return null;
        }
        if (index_1.PageContext.type === FilterTypings_1.FilterableListTypeEnum.SearchResults) {
            return ((0, jsx_runtime_1.jsx)(DownloadSortButton_1.DownloadSortButton, { onChange: sortChangeHandler, sortBy: sortBy, setIsContentLoading: handleSetContentLoading, selectedFilters: selectedFilters }));
        }
        return ((0, jsx_runtime_1.jsx)(SortButton_1.SortButton, { label: index_1.PageContext.dictionary.sortBtnLabel, onChange: sortChangeHandler, options: index_1.PageContext.sortOptions, selected: sortBy }));
    }, [handleSetContentLoading, selectedFilters, sortBy, sortChangeHandler]);
    const renderResetButton = React.useCallback(() => {
        if (!selectedFiltersCount) {
            return null;
        }
        return ((0, jsx_runtime_1.jsxs)("button", { className: "clear-filters-button items-center cursor-pointer outline-offset-[-3px] text-btn-secondary hidden md:flex shrink-0 mt-2", "aria-label": index_1.PageContext.dictionary.resetBtnLabel, onClick: resetFilterHandler, children: [(0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "close", className: "ml-2xs" }), index_1.PageContext.dictionary.resetBtnLabel] }));
    }, [resetFilterHandler, selectedFiltersCount]);
    const renderFilterButton = React.useCallback((filterDisabled = false) => {
        if (!Object.keys(filters).length) {
            return null;
        }
        const count = getSelectedFiltersCount();
        return ((0, jsx_runtime_1.jsxs)("button", { className: "w-full bg-fill-primary px-md! font-regular border-primary text-icon-primary hover:bg-fill-primary-hovered active:bg-fill-primary-pressed disabled:border-disabled disabled:text-icon-disabled md:hidden flex h-[44px] items-center justify-center rounded-2xl border mb-6", onClick: filterDisabled ? undefined : toggleMobileFilter, children: [index_1.PageContext.dictionary.filterBtnLabel, " ", count ? (0, jsx_runtime_1.jsxs)("span", { children: ["\u00A0", `(${count})`] }) : null, (0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "tune-outline", className: "ml-2xs" })] }));
    }, [filters, getSelectedFiltersCount, toggleMobileFilter]);
    const renderDocumentsSearchPageHeading = React.useCallback((filterDisabled = false) => {
        var _a, _b;
        const documentsSearchPageType = additionalData === null || additionalData === void 0 ? void 0 : additionalData.documentsSearchPageType;
        const typeFilters = (_b = (_a = filters[FullTextSearchApi_1.FullTextSearchFilters.TypeFilterAlias]) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : undefined;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "list-heading", children: [(0, jsx_runtime_1.jsx)("div", { className: "heading-wrapper", children: typeFilters && ((0, jsx_runtime_1.jsx)(DocumentsHeader_1.DocumentsHeader, { typeFiltersList: typeFilters, documentsSearchPageType: documentsSearchPageType })) }), (0, jsx_runtime_1.jsxs)("div", { className: "sort-filter-buttons-wrapper", children: [renderResetButton(), renderSortButton(), renderFilterButton(filterDisabled)] }), typeFilters && ((0, jsx_runtime_1.jsx)(DocumentsSearchField_1.DocumentsSearchField, { query: query, typeFiltersList: typeFilters, onChangeQuery: changeQueryHandler, isContentLoading: isContentLoading, setIsContentLoading: handleSetContentLoading, documentsSearchPageType: documentsSearchPageType }))] }));
    }, [
        additionalData,
        changeQueryHandler,
        filters,
        handleSetContentLoading,
        isContentLoading,
        query,
        renderFilterButton,
        renderResetButton,
        renderSortButton,
    ]);
    const renderItems = React.useCallback(() => {
        return ((0, jsx_runtime_1.jsx)(ErrorHandlerComponent_1.ErrorHandlerComponent, { type: ErrorHandlerComponent_1.ErrorGUITypeEnum.special, children: (0, jsx_runtime_1.jsx)(FilterableListItems_1.FilterableListItems, { type: index_1.PageContext.type, dictionary: index_1.PageContext.dictionary, items: items, totalItems: totalItems, selectedFiltersQueryString: selectedFiltersQueryString, currentPage: pageNumber }) }));
    }, [items, pageNumber, selectedFiltersQueryString, totalItems]);
    const renderPagination = React.useCallback(() => {
        if (index_1.PageContext.type === FilterTypings_1.FilterableListTypeEnum.ProductCategories || pageCount < 2) {
            return null;
        }
        return ((0, jsx_runtime_1.jsx)("div", { className: "filterable-list__pagination", children: (0, jsx_runtime_1.jsx)(Pagination_1.default, { pageCount: pageCount, pageSize: pageSize, onPageChange: ({ selected }) => {
                    window.scrollTo(0, 0);
                    setIsContentLoading(true);
                    actions_1.ActionsController.dispatch(actions_1.FilterableListActions.pageChange(selected));
                }, onPageSizeChange: nextPageSize => {
                    setIsContentLoading(true);
                    actions_1.ActionsController.dispatch(actions_1.FilterableListActions.pageSizeChange(nextPageSize));
                }, forcePage: pageNumber }) }));
    }, [pageCount, pageNumber, pageSize]);
    const renderItemsAndPagination = React.useCallback(() => {
        if (isContentLoading) {
            return ((0, jsx_runtime_1.jsx)("div", { className: "spinner-wrapper relative h-screen", children: (0, jsx_runtime_1.jsx)(Spinner_1.Spinner, { visible: true, className: "spinner absolute !top-18" }) }));
        }
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [renderItems(), renderPagination()] }));
    }, [isContentLoading, renderItems, renderPagination]);
    const renderInfoBox = React.useCallback(() => {
        const { showInfoMessage, onInfoMessageClose, informationMessage: infoMessageFromData, } = additionalData !== null && additionalData !== void 0 ? additionalData : {};
        const message = infoMessageFromData !== null && infoMessageFromData !== void 0 ? infoMessageFromData : informationMessage;
        if (message && showInfoMessage) {
            return (0, jsx_runtime_1.jsx)(InfoBox_1.InfoBox, { text: message, onInfoMessageClose: onInfoMessageClose });
        }
        return null;
    }, [additionalData, informationMessage]);
    const renderZeroResultsMessage = React.useCallback(() => {
        var _a;
        const infoMessage = (_a = additionalData === null || additionalData === void 0 ? void 0 : additionalData.informationMessage) !== null && _a !== void 0 ? _a : informationMessage;
        if (zeroResultsMessage && !items.length && !infoMessage) {
            return (0, jsx_runtime_1.jsx)(zeroResultsMessage_1.ZeroResultsMessage, Object.assign({}, zeroResultsMessage));
        }
        return null;
    }, [additionalData, informationMessage, items, zeroResultsMessage]);
    const renderErrorMessage = React.useCallback(() => {
        return (0, jsx_runtime_1.jsx)(ErrorMessage_1.ErrorMessage, Object.assign({}, status));
    }, [status]);
    const renderZeroResultView = React.useCallback((className) => {
        const zeroResultsContainer = ((0, jsx_runtime_1.jsx)(ZeroResultsContainer_1.ZeroResultsContainer, { additionalData: additionalData, className: className, suggestions: suggestions, selectedFiltersQueryString: selectedFiltersQueryString, waitingForResults: waitingForResults || isContentLoading }));
        if (!isDocumentsSearchPage) {
            return zeroResultsContainer;
        }
        return ((0, jsx_runtime_1.jsx)("div", { className: className, children: (0, jsx_runtime_1.jsxs)("div", { className: "list__wrapper", children: [(0, jsx_runtime_1.jsx)("div", { children: renderDocumentsSearchPageHeading(true) }), renderZeroResultsMessage(), (0, jsx_runtime_1.jsx)(ZeroSearchResults_1.ZeroSearchResults, { title: title, recommendations: additionalData.zeroResultsText, centerBlock: true, suggestions: suggestions, selectedFiltersQueryString: selectedFiltersQueryString })] }) }));
    }, [
        additionalData,
        isContentLoading,
        isDocumentsSearchPage,
        renderDocumentsSearchPageHeading,
        renderZeroResultsMessage,
        selectedFiltersQueryString,
        suggestions,
        waitingForResults,
    ]);
    const className = `filterable-list container-px flex max-md:mb-5xl ${index_1.PageContext.type !== FilterTypings_1.FilterableListTypeEnum.SearchResults ? 'my-8 sm:mt-12 sm:mb-24' : ''}`;
    if (status && additionalData && !mobileFilterVisible) {
        if (status.statusCode === ListStatusCode.zeroResults) {
            return renderZeroResultView(className);
        }
        hideZeroResultContent(additionalData);
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: className, children: [(0, jsx_runtime_1.jsx)("div", { className: "filters__wrapper min-w-[282px] hidden md:block", children: !mobileFilterVisible && filterGroupsOrder.length > 0 && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(ErrorHandlerComponent_1.ErrorHandlerComponent, { children: (0, jsx_runtime_1.jsx)(Filters_1.default, { filterGroupsOrder: filterGroupsOrder, filters: filters, selectedFilters: selectedFilters, onFilterChange: changeFilterHandler, dictionary: index_1.PageContext.dictionary, additionalData: additionalData, title: index_1.PageContext.dictionary.filterBtnLabel }) }) })) }), (0, jsx_runtime_1.jsxs)("div", { className: "list__wrapper md:ml-3xl flex-1", children: [(0, jsx_runtime_1.jsx)("div", { ref: breadcrumbsPlaceholder }), !isDocumentsSearchPage ? ((0, jsx_runtime_1.jsxs)("div", { className: "list-heading lg-screen:flex lg-screen:justify-between lg-screen:pt-6", children: [(0, jsx_runtime_1.jsxs)("div", { className: "heading-wrapper", children: [renderHeading(), (0, jsx_runtime_1.jsxs)("div", { className: "flex items-start flex-col mb-6 sm:mb-8 md:flex-row md:items-end md:justify-between", children: [renderSortButton(), renderTotalItems()] })] }), renderFilterButton()] })) : (renderDocumentsSearchPageHeading()), renderSpinner(), selectedFiltersCount > 0 && ((0, jsx_runtime_1.jsxs)("div", { className: "hidden md:flex items-start justify-between mb-4 sm:mb-8 ", children: [renderUnselectButtonsGroup(), renderResetButton()] })), (0, jsx_runtime_1.jsx)(DidYouMean_1.DidYouMean, { suggestions: suggestions, selectedFiltersQueryString: selectedFiltersQueryString, additionalClassNames: "my-4 md:my-6" }), renderErrorMessage(), renderZeroResultsMessage(), renderInfoBox(), renderItemsAndPagination()] }), renderMobileFilter()] }));
};
exports.FilterableList = FilterableList;
